module.exports = __webpack_public_path__ + "static/front/img/customer.9ed8d6b5.svg";